import Controller from '@ember/controller';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class BulkUploadController extends Controller {
  @service
  router;

  @action
  changeTab(newTab) {
    this.router.transitionTo(newTab);
  }
}
